import { LoginDialog } from '../auth/login/loginDialog';
import { BrowserRouter } from 'react-router-dom';
import { RootState } from '../../redux/store';
import GetParameterPopups from '../../popups';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { HomeBar } from '../appBars/homeBar/homeBar';
import { CategoriesAppBar } from '../categories/categoriesAppBar';
import { SocialNetworkBar } from '../appBars/socialNetworksBar/socialNetworkBar';
import MenuDrawer from '../menu/menuDrawer';
import { CopyrightBar } from '../appBars/copyrightBar/copyrightBar';
import { resetLoginRequired } from '../../redux/reducers/authReducer';
import { CookiesBar } from '../cookies/cookiesBar';
import { PasswordChange } from '../auth/accountSettings/passwordChange';
import { useEffect, useState } from 'react';
import WebsiteRoutes from '../../routes/websiteRoutes';
import { Box, useMediaQuery } from '@mui/material';
import { env } from '../../env';
import ScrollToTop from './scrollToTop';
import { FormadaRoutes } from '../../routes/allRoutes';
import CartDrawer from '../shoppingCart/cartDrawer';
import { FacebookAppMeta } from '../../integrations/facebook/FacebookAppMeta';
import { MetaPixelScript } from '../../integrations/facebook/MetaPixelScript';
import { GoogleTagScript } from '../../integrations/google/GoogleTagScript';

function LinosArteleContent() {
  var dispatch = useAppDispatch();
  const isLoginRequired: boolean = useAppSelector((state: RootState) => state.authState.isLoginRequired);
  const isUserLoggedIn = useAppSelector((state: RootState) => state.authState.isLoggedIn);
  const isPasswordRestored = useAppSelector((state: RootState) => state.authState.isPasswordRestored);
  const baseUrl = env.PUBLIC_URL ?? '';
  const [openPasswordChange, setOpenPasswordChange] = useState(false);
  const isLargeSize = useMediaQuery('(min-width:1400px)');

  const closeLogin = () => {
    dispatch(resetLoginRequired());
  };

  useEffect(() => {
    let ogUrlMeta = document.querySelector("meta[property='og:url']");
    if (ogUrlMeta) {
      ogUrlMeta.setAttribute('content', window.location.href);
    }
  }, []);

  useEffect(() => {
    if (isPasswordRestored) {
      if (isUserLoggedIn) {
        setOpenPasswordChange(true);
      }
    } else {
      setOpenPasswordChange(false);
    }
  }, [isPasswordRestored, isUserLoggedIn]);

  const closePasswordChange = () => {
    setOpenPasswordChange(false);
  };

  const getRoutes = () => FormadaRoutes;

  return (
    <Box
      sx={{
        backgroundColor: 'rootContainer.background',
        color: 'rootContainer.color',
        minWidth: '300px',
      }}
    >
      <BrowserRouter basename={baseUrl}>
        <GoogleTagScript />
        <MetaPixelScript />
        <FacebookAppMeta />
        <ScrollToTop />
        <MenuDrawer />
        <CartDrawer />
        <Box
          sx={{
            backgroundColor: 'appBar.top.background',
            height: isLargeSize ? '140px' : '100px',
            position: 'fixed',
            zIndex: 1200,
            width: '100%',
          }}
        >
          <Box maxWidth="xl" sx={{ mx: 'auto' }}>
            <HomeBar />
          </Box>
        </Box>
        <Box
          sx={{
            backgroundColor: 'appBar.top.background',
            pt: '100px',
            '@media (max-width: 700px)': {
              pt: '150px',
            },
            '@media (min-width: 1400px)': {
              pt: '145px',
            },
          }}
        >
          <Box maxWidth="xl" sx={{ mx: 'auto', pb: '10px' }}>
            <CategoriesAppBar />
          </Box>
        </Box>
        <Box maxWidth="xl" sx={{ mx: 'auto', mt: '10px' }}>
          <WebsiteRoutes routes={getRoutes()} />
          <SocialNetworkBar />
          <CopyrightBar />
        </Box>
        <GetParameterPopups />
        <LoginDialog open={isLoginRequired} onClose={closeLogin} />
        <CookiesBar />
        <PasswordChange open={openPasswordChange} onClose={closePasswordChange} />
      </BrowserRouter>
    </Box>
  );
}
export default LinosArteleContent;
